import PropTypes from 'prop-types';
import { Fragment, Component } from 'react';
import { capture, SentryEventIds, createFingerprint } from 'dashboard-lib/public/sentry';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Blank = () => null;
const defaultOnError = (error, errorBoundaryName) => {
  capture(errorBoundaryName, {
    error,
    fingerprint: createFingerprint(error)
  });
};
class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false,
      error: undefined
    };
    this.componentDidCatch = error => {
      const {
        onError = defaultOnError,
        name = SentryEventIds.DEFAULT_DASHBOARDS_APP_ERROR_BOUNDARY
      } = this.props;
      onError(error, name);
    };
    this.render = () => {
      const {
        ErrorComponent = Blank,
        children
      } = this.props;
      const {
        hasError,
        error
      } = this.state;
      return hasError ? /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          "data-test-id": "error-boundary"
        }), /*#__PURE__*/_jsx(ErrorComponent, {
          error: error
        })]
      }) : children;
    };
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.node,
  onError: PropTypes.func,
  ErrorComponent: PropTypes.elementType
};
ErrorBoundary.defaultProps = {
  children: null,
  onError: defaultOnError,
  ErrorComponent: Blank,
  name: SentryEventIds.DEFAULT_DASHBOARDS_APP_ERROR_BOUNDARY
};
ErrorBoundary.getDerivedStateFromError = error => ({
  hasError: true,
  error
});
export { ErrorBoundary };
export default ErrorBoundary;